import type { ExternalLinkItemDto } from '@up2stay/up2promo-api-client';
import { ExternalLinkType } from '@up2stay/up2promo-api-client';

import type { LinkedProductSummary } from '@/core/hooks/use-location-linked-products';

/** Debounce windows — address is high-stakes; name/contact need room to type. */
export const NAME_AUTOSAVE_MS = 800;
export const CONTACT_AUTOSAVE_MS = 1000;
export const ADDRESS_AUTOSAVE_MS = 1500;
export const LINKS_AUTOSAVE_MS = 1000;

export function isBreakingExternalLinksChange(
  existing: Array<{ type: ExternalLinkType; value: string }>,
  next: ExternalLinkItemDto[],
  linkedProducts: LinkedProductSummary[],
): boolean {
  const productTypes = new Set(
    linkedProducts.map((p) => p.productType).filter((t): t is string => !!t),
  );

  const linkRemoved = (type: ExternalLinkType, productType: string) => {
    if (!productTypes.has(productType)) return false;
    const prev = existing.find((e) => e.type === type)?.value?.trim();
    const nxt = next.find((e) => e.type === type)?.value?.trim();
    return !!prev && !nxt;
  };

  return (
    linkRemoved(ExternalLinkType.INSTAGRAM, 'IG') ||
    linkRemoved(ExternalLinkType.FACEBOOK, 'FB') ||
    linkRemoved(ExternalLinkType.TIKTOK, 'TT') ||
    linkRemoved(ExternalLinkType.MENU, 'ME')
  );
}
